export const environment = {
  production: true,
  apiBaseUrl: 'https://api.home-home.org',
  // CloudFront fallback URL for DNS resolution failures (Cloudflare DNS outage fallback)
  apiFallbackUrl: 'https://d3rwolabvvc5d8.cloudfront.net',
  wsUrl: 'wss://api.home-home.org/',
  adminRoleUuid: {
    shelter: '6286cc6e-2be5-4fe3-a72c-54ec3a988d59',
    super: 'd7b325bc-40a5-4e83-ab49-bc0efd8de5ed',
  },
  hqShelterUuid: 'b688be43-d01f-4005-8c81-e1dea439c111',
  logLevel: 'error',
  stripePubKey:
    'pk_live_51JnVzSA3AvI08Dfn2LhoeoYbIMVIxazCNFJh0NwwZxqQuCdm3WQaeenbSpp3DwDRE0tu3Aqm9PnMj7jvt4IrIAMx00mhWXSbVf',
  turnstileSiteKey: '0x4AAAAAABD5802ZGtx5_Ivm',
  featureFlags: {
    documentImage: false,
    bypassVerificationPayment: false,
    autoSpamReporting: false,
    spamReports: false,
    deactivate: true,
    verifiedReceipt: false,
    verifyPromo: false,
    boostButtons: true,
    bioBuilder: true,
    petAttributes: true,
    metlifeAds: true,
    externalAds: false, // H2H028 — disabled pending AdSense third-party CDN audit (totallyacdn.com Basic-Auth prompts)
    externalAdsHome: false,
    externalAdsSearch: false,
    externalAdsPetDetail: false,
    fundraisingThermometer: false,
    homePageCarousel: false,
    adoptionFlow: false,
    facebookPosting: true,
  },
  bypassVerificationPayment: false,
  enableVerification: true,
}
